module.exports = __webpack_public_path__ + "static/media/iconBills.911edc2a.svg";